// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"a3badbef","200":"ea794885","931":"12971246"}[chunkId] + ".chunk.js";
};